import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ReferenceLine, ResponsiveContainer
} from 'recharts';

export function HistogramChart({ data, wearPosition, socValue }) {
  // Transform histogram array [2,5,7,...] into chart-friendly format
  const chartData = data.map((count, index) => ({
    wear: index, // bin index
    count
  }));

  return (
      <ResponsiveContainer width="100%" height={175}>
        <BarChart
          width={400}
          height={120}
          data={chartData}
          margin={{ top: 30, right: 50, left: 0, bottom: 10 }}
        >
          <XAxis
            dataKey="wear"
            label={{ value: "Less Wear → More Wear", position: "insideBottom", offset: -5, fontSize: 15 }}
            tick={{ fontSize: 10 }}
          />
          <YAxis  tick={{ fontSize: 10 }}/>
          {/* <Tooltip /> */}
          <Bar
            dataKey="count"
            fill='#5fb0dfff'
            radius={[8, 8, 0, 0]}
            barSize={8}  // smaller bars (default is usually bigger)
          />

          <ReferenceLine
            x={wearPosition}
            stroke="green"
            strokeWidth={2}
            label={{ value: '▼', position: 'top', fill: 'green' }}
          />

        </BarChart>
      
      </ResponsiveContainer>
 

  );
}
